import { render, staticRenderFns } from "./BlockSetDialog.vue?vue&type=template&id=5bf88c42&scoped=true&"
import script from "./BlockSetDialog.vue?vue&type=script&lang=js&"
export * from "./BlockSetDialog.vue?vue&type=script&lang=js&"
import style0 from "./BlockSetDialog.vue?vue&type=style&index=0&id=5bf88c42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf88c42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bf88c42')) {
      api.createRecord('5bf88c42', component.options)
    } else {
      api.reload('5bf88c42', component.options)
    }
    module.hot.accept("./BlockSetDialog.vue?vue&type=template&id=5bf88c42&scoped=true&", function () {
      api.rerender('5bf88c42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/pageUICustom/BlockSetDialog.vue"
export default component.exports